<template>
    <pendo-multiselect-filter
        v-model="selectedOptions"
        :loading="fetching"
        :options="options"
        :show-search="true"
        entity-name="Pages"
        label-key="name"
        @input="setSelectedOptions" />
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { PendoMultiselectFilter } from '@pendo/components';

export default {
    name: 'MultiselectPagesFilter',
    components: {
        PendoMultiselectFilter,
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['input'],
    data () {
        return {
            loadTriggered: false,
            options: [],
        };
    },
    computed: {
        ...mapState('pages', ['fetching']),
        ...mapGetters('pages', ['list']),
        selectedOptions () {
            return this.options.filter((page) => this.value.includes(page));
        },
    },
    watch: {
        list: 'setOptions',
    },
    created () {
        this.loadOptions();
    },
    methods: {
        ...mapActions('pages', ['loadAll']),
        async loadOptions () {
            if (this.loadTriggered) return;
            this.loadTriggered = true;
            await this.loadAll();
            this.setOptions();
        },
        setOptions () {
            const pagesList = ['Sitewide'];
            const sortedPages = this.list.map((page) => page.name).sort();

            this.options = pagesList.concat(sortedPages);
        },
        setSelectedOptions (value) {
            this.$emit('input', value);
        },
    },
};
</script>

<style lang="less" scoped>
:deep(.pendo-multiselect__option) {
    padding: 0 8px 0 16px;
}
</style>
